import { useState, useEffect } from 'react';
import api from '../../services/api';
import { AvatarDisplay } from '../../components/common/AvatarUpload';import "../../assets/styles/Intern/PeopleSection.css";

function PeopleSection() {
  const [people, setPeople] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  useEffect(() => {
    api.getPeopleDirectory().then((d) => {setPeople(d || []);setLoading(false);}).catch(() => setLoading(false));
  }, []);

  const filtered = people.filter((p) => {
    if (!search) return true;
    const q = search.toLowerCase();
    return (p.name || '').toLowerCase().includes(q) || (p.designation || '').toLowerCase().includes(q) || (p.department || '').toLowerCase().includes(q) || (p.emp_id || '').toLowerCase().includes(q);
  });

  return (
    <div>
      <input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search people..." className="peoplesection-inline-1" />
      
      {loading ? <div className="peoplesection-inline-2">Loading...</div> :
      filtered.length === 0 ? <div className="peoplesection-inline-3">No people found</div> :
      <div className="peoplesection-inline-4">
        {filtered.map((p) =>
        <div key={p.id || p.emp_id} className="card peoplesection-inline-5">
            <AvatarDisplay src={p.avatar} name={p.name} size={40} />
            <div>
              <div className="peoplesection-inline-6">{p.name}</div>
              <div className="peoplesection-inline-7">{p.designation || p.role || '—'}</div>
              <div className="peoplesection-inline-8">{p.department || '—'} · {p.emp_id || ''}</div>
            </div>
          </div>
        )}
      </div>}
    </div>);

}

export default PeopleSection;